export function getEntityPrimaryKey(collection) {
  var _schema$fields;
  const schema = collection.entity;
  if (!schema) {
    return null;
  }
  // const target = schemaFind(schema, (s) => s.isPrimaryKey === true);
  const target = (_schema$fields = schema.fields) === null || _schema$fields === void 0 ? void 0 : _schema$fields.find(item => item.isPrimaryKey === true); // 只遍历第一层，关系型数据源有多个主键
  return (target === null || target === void 0 ? void 0 : target.id) || null;
}
//# sourceMappingURL=getEntityPrimaryKey.js.map
